export default {

    // Valeurs formulaire facture
    tnfac: '',
    tnfac_selected: '',
    fdate_fact: '',
    reset_invoice_list: false,
    fncde: '',
    launch: false,

    delivery_pnbl: '',

    // Valeurs formulaire BL
    delivery_tnbl: '',
    delivery_tnfact: '',
    delivery_tdate_bl: '',
    delivery_fncde: '',
    launch_delivery_research: false,
    reset_delivery_list: false,

    // Valeurs formulaire details BL
    delivery_details_tmod: '',
    delivery_details_tcol: '',
    delivery_details_ttaille: '',
    delivery_details_trefc: '',
    launch_delivery_details_research: false,
};